module.exports = new __parcel__URL__("space_elixir_storage_level_11.fe8d1366.png").toString();